"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
exports.isRenderNothing = void 0; // Generated by CoffeeScript 2.3.2

var nonce;
nonce = {}; // eslint-disable-next-line known-imports/no-unused-vars

var isRenderNothing = function isRenderNothing(val) {
  return val === nonce;
};

exports.isRenderNothing = isRenderNothing;

function _default() {
  return function () {
    return nonce;
  };
}

;